export { ca } from '@payloadcms/translations/languages/ca'
